import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';

const Navigation = () => {
  return (
    <Navbar className="navigation-bar"  variant="dark" expand="lg">
      <Container className="navigation-bar-container">
        <Navbar.Brand href="/">
          <img 
            src="/JCI-new-logo.png" 
            alt="" 
            className="navbar-logo"
          />
          <img src="rock-on-logo.png" className="rock-on-logo"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav>
            <NavDropdown title="About Us" className="nav-dropdown">
              <NavDropdown.Item href="/about-us">About JCI Lucena</NavDropdown.Item>
              <NavDropdown.Item href="/board-of-directors">Board of Directors</NavDropdown.Item>
              {/* <NavDropdown.Item href="/our-presidents">Our Presidents</NavDropdown.Item> */}
            </NavDropdown>
            <Nav.Link href="/projects">Projects</Nav.Link>
            <Nav.Link href="/our-publication">The Clarion</Nav.Link>
            <Nav.Link href="/contact-us">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
